import React from 'react';
import * as Styles from './NewMacroStep3.style';
import { StepLabel } from 'components/step-label/StepLabel';
import Input from 'components/input';

const NewMacroStep3 = ({ formikProp, edited }) => {
  const { values, handleChange, errors, touched, handleBlur } = formikProp;
  return (
    <Styles.NewMacroStep3SC>
      <StepLabel id="ST3" stepCount={'Step 3'}>
        {edited ? `Do you wish to edit the label for this macro?` : `Specify a label for this macro`}
      </StepLabel>
      <Styles.StepDescription>
        This is just an internal name to reference a label. For example: "authorization form request"
      </Styles.StepDescription>
      <Styles.SubmitReply>
        <Input
          name={'label'}
          value={values['label']}
          placeholder={'Label'}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors['label']}
          touched={touched['label']}
        />
      </Styles.SubmitReply>
    </Styles.NewMacroStep3SC>
  );
};
export default NewMacroStep3;
